module.exports = __webpack_public_path__ + "static/ConcreteBG_light_top-d530a3664e5438ef2f2128b179efd3b1.jpg";